import { useI18n } from 'vue-i18n'

export enum FocAlert {
  FOC_ALERT_1 = 1,
  FOC_ALERT_2 = 2,
  FOC_ALERT_3 = 3,
  FOC_ALERT_4 = 4
}

export namespace FocAlert {
  export function getLabel(alert: FocAlert): string {
    const { t } = useI18n()
    switch (alert) {
      case FocAlert.FOC_ALERT_1:
        return t('focAlerts.level1')
      case FocAlert.FOC_ALERT_2:
        return t('focAlerts.level2')
      case FocAlert.FOC_ALERT_3:
        return t('focAlerts.level3')
      case FocAlert.FOC_ALERT_4:
        return t('focAlerts.level4')
    }
  }

  export function getSelectOptions(): { value: FocAlert; label: string }[] {
    return [
      {
        value: FocAlert.FOC_ALERT_1,
        label: getLabel(FocAlert.FOC_ALERT_1)
      },
      {
        value: FocAlert.FOC_ALERT_2,
        label: getLabel(FocAlert.FOC_ALERT_2)
      },
      {
        value: FocAlert.FOC_ALERT_3,
        label: getLabel(FocAlert.FOC_ALERT_3)
      },
      {
        value: FocAlert.FOC_ALERT_4,
        label: getLabel(FocAlert.FOC_ALERT_4)
      }
    ]
  }

  export function getColor(alert: FocAlert) {
    switch (alert) {
      case FocAlert.FOC_ALERT_1:
        return '#DCE9EF'
      case FocAlert.FOC_ALERT_2:
        return '#F6FF6D'
      case FocAlert.FOC_ALERT_3:
        return '#FF7F00'
      case FocAlert.FOC_ALERT_4:
        return '#EA3E3E'
    }
  }
}
